<template>
  <div class="userinfo" v-loading="loading">
    <back />
    <div class="information">
      <div class="label">
        <span>基本信息</span>
        <el-button type="primary" size="" @click="onSave('form')">保存</el-button>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" class="demo-form">
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="姓名" prop="nickName">
              <el-input v-model="form.nickName" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="7">
            <el-form-item label="性别">
              <el-input v-model="form.sexs" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="手机号码" prop="phoneNum">
              <el-input v-model="form.phoneNum" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="注册时间">
              <el-input v-model="form.createdTime" placeholder="请输入内容" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="紧急联系人" prop="emergencyContact">
              <el-input v-model="form.emergencyContact" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="紧急联系电话" prop="emergencyContactNumber">
              <el-input v-model="form.emergencyContactNumber" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="是否随从">
              <el-select v-model="form.retinue" placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="出生日期">
              <el-date-picker v-model="form.birthDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="爱好">
              <el-input v-model="form.hobby" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="是否随从">
              <el-select v-model="form.retinue" placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="21">
            <el-form-item label="病例">
              <el-input v-model="form.cases" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="21">
            <el-form-item label="家庭状况">
              <el-input v-model="form.familySituation" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="21">
            <el-form-item label="忌口">
              <el-input v-model="form.dieteticRestraint" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="21">
            <el-form-item label="药物">
              <el-input v-model="form.drugs" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-descriptions title="基本信息" :column="4">
        <el-descriptions-item label="姓名">{{ uinfo.userName }}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{ uinfo.userPhone }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ uinfo.createdTime }}</el-descriptions-item>
      </el-descriptions> -->
    </div>

    <el-divider></el-divider>

    <div class="follow_record">
      <div class="label">
        <span>随访记录</span>
        <el-button type="primary" size="" @click="handleAddFollow">新增</el-button>
      </div>
      <div class="g_table">
        <el-table :data="follow" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="updatedTime" label="时间"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createdUserName" label="记录人"></el-table-column>
          <el-table-column show-overflow-tooltip prop="followContent" label="随访记录"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="primary" plain @click="handleEditFollow(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    </div>

    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible" width="800px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="ruleForm">
        <el-form-item label="随访记录" required>
          <el-input v-model="ruleForm.followContent" type="textarea" :rows="5" maxlength="100" show-word-limit placeholder="请输入随访记录"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitLoding">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createForm() {
  return {
    nickName: "",
    phoneNum: "",
    createdTime: "",
    emergencyContact: "",
    emergencyContactNumber: "",
    retinue: "",
    birthDate: "",
    hobby: "",
    cases: "",
    familySituation: "",
    dieteticRestraint: "",
    drugs: "",
  }
}
function createRuleForm() {
  return {
    userId: "",
    followContent: "",
  }
}
export default {
  data() {
    return {
      loading: false,
      uinfo: this.$route.query,
      reservation: [],
      follow: [],
      isAdd: false,
      dialogVisible: false,
      submitLoding: false,
      ruleForm: createRuleForm(),
      form: createForm(),
      rules: {
        nickName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phoneNum: [{ required: true, message: "请输入电话", trigger: "blur" }],
        emergencyContact: [{ required: true, message: "请输入紧急联系人", trigger: "blur" }],
        emergencyContactNumber: [{ required: true, message: "请输入紧急联系电话", trigger: "blur" }],
      },

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取用户信息
    getInfo() {
      this.loaading = true
      this.$axios
        .get(this.$api.customerFollowselectUserDetail, {
          params: {
            userId: this.$route.query.userId,
          },
        })
        .then(res => {
          let sex = res.result.sex
          this.form = res.result
          this.form.sexs = sex == 1 ? "男" : sex == 0 ? "女" : "未知"
          this.loaading = false
          this.getCustomerFollow()
        })
        .catch(err => {
          this.loaading = false
          this.$message.error(err.desc)
        })
    },
    // 获取用户随访记录
    getCustomerFollow() {
      this.$axios
        .get(this.$api.customerFollowselectCustomerFollow, {
          params: {
            userId: this.$route.query.userId,
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.follow = res.result.list
          this.totalItemsCount = res.result.totalCount
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 切换每页显示的条数
    handleSizeChange2(e) {
      this.reservation = []
      this.pageSize = e
      this.getCustomerFollow()
    },
    // 换页
    handleCurrentChange2(e) {
      this.reservation = []
      this.currentPage = e
      this.getCustomerFollow()
    },
    // 修改记录
    handleEditFollow(row) {
      this.ruleForm = Object.assign({}, row)
      this.isAdd = false
      this.dialogVisible = true
    },
    // 新增记录
    handleAddFollow() {
      this.isAdd = true
      this.dialogVisible = true
    },
    onCancel() {
      this.ruleForm = createRuleForm()
      this.dialogVisible = false
    },
    onSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = Object.assign({}, this.form)
          params.userId = this.$route.query.userId
          this.$delete(params, "id")
          this.$axios
            .post(this.$api.customerFollowsaveUserDetail, params)
            .then(res => {
              this.$message.success("保存成功")
              this.getInfo()
              // setTimeout(() => {
              //   this.$router.go(-1)
              // }, 500)
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("提交失败")
          return false
        }
      })
    },
    onSubmit() {
      if (this.ruleForm.followContent == "") {
        this.$message.error("请输入随访记录")
        return
      } else {
        this.submitLoding = true
        let api = null
        let params = Object.assign({}, this.ruleForm)
        if (this.isAdd) {
          api = this.$api.customerFollowinsert
          this.$delete(params, "id")
        } else {
          api = this.$api.customerFollowupdate
        }
        params.userId = this.$route.query.userId
        this.$axios
          .post(api, params)
          .then(res => {
            this.$message.success(`${this.isAdd ? "新增" : "修改"}成功`)
            this.ruleForm = createRuleForm()
            this.getCustomerFollow()
            this.submitLoding = false
            this.dialogVisible = false
          })
          .catch(err => {
            this.submitLoding = false
            this.$message.error(err.desc)
          })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.userinfo {
  .information {
    margin-top: 20px;
    ::v-deep .el-select {
      display: block;
    }
    ::v-deep .el-date-editor {
      width: 100% !important;
    }
    ::v-deep .el-form-item__label {
      padding-right: 20px;
    }
  }

  .label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
</style>
